"use client";

import { useEffect } from "react";
import {
  sessionItems,
  sessionStorageExpiring,
} from "@/utils/sessionStorage";

const DEBOUNCE_TIME = 3 * 1000; // 3 seconds

/**
 * Headless component that manages session lifecycle.
 * Polls the session ID every 3s to detect expiry, and refreshes
 * expiry timestamps on user activity (debounced).
 */
export function SessionManager() {
  useEffect(() => {
    const events: Array<keyof WindowEventMap> = [
      "click",
      "keydown",
      "scroll",
      "mousemove",
    ];
    let lastUpdate = 0;

    // On user activity, extend the expiry of every stored session item
    const refreshOnActivity = () => {
      const now = Date.now();
      if (now - lastUpdate < DEBOUNCE_TIME) return;
      lastUpdate = now;

      sessionStorageExpiring.refreshAllExpiry();
    };

    events.forEach((event) =>
      window.addEventListener(event, refreshOnActivity)
    );

    // Trigger an initial session ID check (creates one if needed)
    sessionStorageExpiring.get(sessionItems.SESSION_ID);

    // Poll session ID every DEBOUNCE_TIME
    const intervalId = setInterval(() => {
      sessionStorageExpiring.get(sessionItems.SESSION_ID);
    }, DEBOUNCE_TIME);

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, refreshOnActivity)
      );
      clearInterval(intervalId);
    };
  }, []);

  return null;
}
